export const ENV = {
  WS_SERVER_URL: (import.meta.env['VITE_WS_URL'] as string) ?? 'ws://localhost:3001',
  IS_DEV: import.meta.env.DEV as boolean,
  VERSION: (import.meta.env['VITE_APP_VERSION'] as string) ?? '0.1.0',
  // TODO: Owner must set these API keys before App Store submission.
  // Obtain from: https://app.revenuecat.com/projects → API keys → Public app-specific keys
  REVENUECAT_API_KEY_IOS: (import.meta.env['VITE_REVENUECAT_API_KEY_IOS'] as string) ?? '',
  REVENUECAT_API_KEY_ANDROID: (import.meta.env['VITE_REVENUECAT_API_KEY_ANDROID'] as string) ?? '',
  // Set VITE_USE_POSTGRES=true to use PostgresPersistenceAdapter instead of LocalStorageAdapter.
  // Required on native Capacitor builds or when a DATABASE_URL is available server-side.
  USE_POSTGRES: (import.meta.env['VITE_USE_POSTGRES'] as string) === 'true',
  // Firebase Analytics (web platform only — native uses @capacitor-firebase/analytics).
  // Obtain from: console.firebase.google.com → Project Settings → Your apps → Web app
  FIREBASE_API_KEY:            (import.meta.env['VITE_FIREBASE_API_KEY'] as string)             ?? '',
  FIREBASE_AUTH_DOMAIN:        (import.meta.env['VITE_FIREBASE_AUTH_DOMAIN'] as string)         ?? '',
  FIREBASE_PROJECT_ID:         (import.meta.env['VITE_FIREBASE_PROJECT_ID'] as string)          ?? '',
  FIREBASE_STORAGE_BUCKET:     (import.meta.env['VITE_FIREBASE_STORAGE_BUCKET'] as string)      ?? '',
  FIREBASE_MESSAGING_SENDER_ID:(import.meta.env['VITE_FIREBASE_MESSAGING_SENDER_ID'] as string) ?? '',
  FIREBASE_APP_ID:             (import.meta.env['VITE_FIREBASE_APP_ID'] as string)              ?? '',
  FIREBASE_MEASUREMENT_ID:     (import.meta.env['VITE_FIREBASE_MEASUREMENT_ID'] as string)      ?? '',
  // Google OAuth — obtain from console.cloud.google.com → APIs → Credentials → OAuth 2.0 Client ID
  GOOGLE_CLIENT_ID: (import.meta.env['VITE_GOOGLE_CLIENT_ID'] as string) ?? '',
} as const
